import type { StaticImageData } from "next/image";

import ar from "@repo/ui/assets/flags/ar.svg";
import br from "@repo/ui/assets/flags/br.svg";
import cl from "@repo/ui/assets/flags/cl.svg";
import co from "@repo/ui/assets/flags/co.svg";
import ec from "@repo/ui/assets/flags/ec.svg";
import pe from "@repo/ui/assets/flags/pe.svg";
import py from "@repo/ui/assets/flags/py.svg";
import us from "@repo/ui/assets/flags/us.svg";
import uy from "@repo/ui/assets/flags/uy.svg";

export type Country = {
  code: string;
  name: string;
  img: StaticImageData | string;
};

export const countries: Country[] = [
  { code: "cl", name: "Chile", img: cl },
  { code: "ec", name: "Ecuador", img: ec },
  { code: "pe", name: "Peru", img: pe },
  { code: "ar", name: "Argentina", img: ar },
  { code: "br", name: "Brasil", img: br },
  { code: "co", name: "Colombia", img: co },
  { code: "py", name: "Paraguay", img: py },
  { code: "uy", name: "Uruguay", img: uy },
  { code: "us", name: "English", img: us },
];

export const phoneCountryCode = {
  Chile: "CL-56",
};
